<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Reuniões' | translate}}</ion-title>

    <ion-col class="end-filter">
      <div id="open-filter">
        <i class="fa-solid fa-filter"></i>
      </div>
    </ion-col>
  </ion-buttons>
</ion-header>

<ion-content class="schedule-content">
  <div class="gradient-extendido">
    <ion-segment
      mode="ios"
      class="segment-gradient-title"
      [(ngModel)]="reuniaoTab"
      [scrollable]="true"
      value="andamento"
      (ionChange)="onSegmentChange($event)"
    >
      <ion-segment-button value="andamento">
        <ion-label class="header">{{'Em andamento' | translate}}</ion-label>
      </ion-segment-button>

      <ion-segment-button value="finalizado">
        <ion-label class="header">{{'Finalizado' | translate}}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>

  <div [ngSwitch]="reuniaoTab">
    <div *ngSwitchCase="'andamento'">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <div>
            <ion-note slot="start">
              <i class="fas fa-calendar-week div-icon"></i>
            </ion-note>

            <ion-label class="color-title"> {{'Reuniões em andamento' | translate}} </ion-label>
          </div>
          
          <ion-note (click)="orderDescAsc()" slot="end">
            <i class="fa-regular fa-arrow-down-arrow-up div-icon"></i>
          </ion-note>
        </div>

        <ion-list *ngFor="let reuniao of reunioes">
          <div class="list-item" *ngIf="reuniao.status == 0">
            <ion-grid class="grid">
              <ion-row (click)="selecionarReuniao(reuniao)">
                <ion-col size="2">
                  <ion-note>
                    <i class="fas fa-calendar-week icon-list"></i>
                  </ion-note>
                </ion-col>

                <ion-col size="9">
                  <ion-label>
                    <h5>{{reuniao.tema}}</h5>

                    <div>
                      <p>{{ reuniao.dataInicio | dateFormat: 'completa' }}</p>
                    </div>
                  </ion-label>
                </ion-col>

                <ion-col size="1">
                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-col>
              </ion-row>

              <ion-item-divider></ion-item-divider>
            </ion-grid>
          </div>
        </ion-list>
      </div>

      <ion-infinite-scroll (ionInfinite)="carregarReunioes($event, false)" *ngIf="pagination.currentPage < pagination.pageCount">
        <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </div>

    <div *ngSwitchCase="'finalizado'">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <div>
            <ion-note slot="start">
              <i class="fas fa-calendar-week div-icon"></i>
            </ion-note>

            <ion-label class="color-title"> {{'Reuniões Finalizadas' | translate}} </ion-label>
          </div>

          <ion-note (click)="orderDescAsc()" slot="end">
            <i class="fa-regular fa-arrow-down-arrow-up div-icon"></i>
          </ion-note>
        </div>

        <ion-list *ngFor="let reuniao of reunioesFinalizadas">
          <div class="list-item" *ngIf="reuniao.status != 0">
            <ion-grid class="grid">
              <ion-row (click)="selecionarReuniao(reuniao)">
                <ion-col size="2">
                  <ion-note>
                    <ion-icon *ngIf="reuniao.status != 2" name="checkmark-circle" class="b"></ion-icon>

                    <ion-icon *ngIf="reuniao.status != 1" name="remove-circle" class="c"></ion-icon>
                  </ion-note>
                </ion-col>

                <ion-col size="9">
                  <ion-label>
                    <h5>{{reuniao.tema}}</h5>

                    <div>
                      <p>{{ reuniao.formatada }}</p>
                    </div>
                  </ion-label>
                </ion-col>

                <ion-col size="1">
                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-col>
              </ion-row>

              <ion-item-divider></ion-item-divider>
            </ion-grid>
          </div>
        </ion-list>
      </div>

      <ion-infinite-scroll (ionInfinite)="carregarReunioes($event, true)" *ngIf="pagination.currentPage < pagination.pageCount">
        <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </div>
  </div>

</ion-content>

<ion-fab class="fabs" slot="fixed" vertical="bottom" horizontal="end" *ngIf="!userProvider.hasConfig(55)">
  <ion-fab-button>
    <i class="fa-regular fa-plus"></i>
  </ion-fab-button>

  <ion-fab-list side="start" [ngSwitch]="tipo">
    <ion-fab-button class="color-fab-button" style="--border-radius: 1rem !important" (click)="addReuniao();">
      {{'Adicionar Nova Reunião' | translate}}
    </ion-fab-button>
  </ion-fab-list>
</ion-fab>

<ion-modal #filtroModal trigger="open-filter" [initialBreakpoint]="1" [breakpoints]="[0, 1]">
  <ng-template>
    <div class="ion-padding-horizontal ion-margin-top">
      <prover-datepicker
        [labelName]="'Data Início'"
        [id]="'dataInicio'"
        [(dateTime)]="dataInicio"
        [required]="false"
      ></prover-datepicker>
    </div>

    <div class="ion-padding-horizontal">
      <prover-datepicker
        [labelName]="'Data Fim'"
        [id]="'dataFim'"
        [(dateTime)]="dataFim"
        [required]="false"
      ></prover-datepicker>
    </div>

    <div class="ion-margin-vertical" (click)="filtrar()">
      <ion-button class="btn-default" expand="block"> {{'Filtrar' | translate }} </ion-button>
    </div>
  </ng-template>
</ion-modal>
